// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"449":"d715e5ba","488":"fc3c258c","684":"adaa9f88","951":"9e7a7bac","953":"191c4891"}[chunkId] + ".chunk.js";
};